var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"field",staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled,"name":_vm.name,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"required":_vm.required},domProps:{"value":_vm.value},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"change":_vm.onChange,"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }